module.exports = __webpack_public_path__ + "static/Guggenheim_Desktop-183fa6f914e516bd87e0329f869347b8.jpg";